<template>
    <div id="page_09" class="page">
        <div class="content">
            <div class="content_area">
                <div class="content_1">
                <p>
                    <span>Supreme,  Palace, Bape&nbsp;&nbsp;</span><br/>
                    <span>Comme des Garçons, Ben Davis  등&nbsp;&nbsp;</span><br/>
                    <span>프리미엄 스트릿 브랜드를 오프라인에서  만나다.&nbsp;&nbsp;</span>
                </p>
                </div>
                <div class="content_2">
                    <div style="font-weight:bold;">
                        주식회사 써드베이스
                    </div>
                    <div>
                        본사 | 서울시 금천구 가산디지털 1로 142 더 스카이벨리 지식산업센터 905호, 08507
                    </div>
                    <div>
                        창업문의 
                        <a href="tel:010-9296-3837">010-9296-3837</a>
                    </div>
                    <div>
                        홈페이지 
                        <a href="https://specimen.co.kr/" target="_blank">https://specimen.co.kr/</a>
                    </div>
                </div>
            </div>
        </div>
    </div>    
</template>

<script>
export default {
    name: "Page09"
}
</script>

<style scoped>
    .content{padding-top:2.952rem;padding-bottom:1.406rem;}
    span{border-bottom:0.1rem solid #000;}
    .content_1{text-align:right;margin-right:5.56rem;font-weight:bold;font-size:1.02rem;line-height:1.8rem;}
    .content_2{margin-top:5.916rem;font-size:0.52rem;line-height:0.76rem;margin-left:5.56rem;}

    @media (max-width:720px) {
        .content_1{text-align:center;margin:0;}
        .content_2{text-align:center;margin:0;margin-top:6rem;}
    }     
</style>


